import CONST_REQUEST from '../../constants/request';
import * as api from '../../webpublicapi/order';
import apiTools from '../../utils/store'

const types = {
    ...apiTools.getTypes([
        'orderDetail',
        'orderDetailForCollection',
        'repayPlanList',
        'examineLogList',
        'collectionLogList',
        'orderNumberList',
        'addressBookList',
        'repayRecordList',
      'payoutRecordList',
        'repayRecordListV2',
         'orderImageList'
    ]),
}

const getDefaultState = () => {
    return {
        ...apiTools.getStates([
            'orderDetail',
            'orderDetailForCollection',
            'repayPlanList',
            'examineLogList',
            'collectionLogList',
          'orderNumberList',
            'addressBookList',
            'repayRecordList',
            'repayRecordListV2',
          'payoutRecordList',
          'orderImageList'
        ]),
    }
}

const getters = {
        ...apiTools.getGetters([
            'orderDetail',
            'orderDetailForCollection',
            'repayPlanList',
            'examineLogList',
            'collectionLogList',
          'orderNumberList',
            'addressBookList',
            'repayRecordList',
          'payoutRecordList',
            'repayRecordListV2',
          'orderImageList'
        ])
    }

const buildAction = (apiName) => {
    return ({ commit }, params) => {
        return api[apiName](params).then((res) => {
            if (res.code == CONST_REQUEST.CODE_SUCCESS) {
                return res
            } else {
                throw new Error(res.msg)
            }
        })
    }
}

const actions = {
        ...apiTools.getActions([
            'getOrderDetail',
            'getOrderDetailForCollection',
            'getRepayPlanList',
            'getExamineLogList',
            'getCollectionLogList',
            'getOrderNumberList',
            'getRepayRecordList',
            'getRepayRecordListV2',
            'getRepaymentReport',
            'downRepaymentReportExcel',
            'getAddressBookList',
            'getOrderImageList',
            'getOverdueReportRate',
          'getPayoutRecordList',
            'downOverdueReportExcel'

        ], { types, api, CONST_REQUEST }),
    }

const mutations = {
    ...apiTools.getMutations([
        'orderDetail',
        'orderDetailForCollection',
        'repayPlanList',
        'examineLogList',
        'collectionLogList',
        'addressBookList',
        'orderNumberList',
        'repayRecordList',
        'repayRecordListV2',
      'payoutRecordList',
      'orderImageList'

    ], { types, CONST_REQUEST })
}


export default {
    namespaced: true,
    state: getDefaultState(),
    getters,
    actions,
    mutations
}